// extracted by mini-css-extract-plugin
export default {"wrapper":"ReviewCard_wrapper__LiQOt","rating":"ReviewCard_rating__XVg1T"};